// extracted by mini-css-extract-plugin
export default {"Loading":"rnalVAFN7g","Spinner":"Cr51wTbVMx","spinner":"QKTrPSvpri"};